import axios from 'axios'

export default {
    namespaced: true,
    state: {
        clients: []
    },
    mutations: {
        GET_CLIENTS(state, payload){
            state.clients = payload
        },
    },
    actions: {
        clients({ commit, getters }) {
            return new Promise((resolve, reject) => {
                axios.get('client')
                .then(res => {
                    commit('GET_CLIENTS', res.data.data)
                    resolve(res.data.data)
                })
                .catch(error => {
                    reject(error.response)
                })
            })
        },
        show({ commit, getters }, _id) {
            return new Promise((resolve, reject) => {
                axios.get(`client/${_id}`)
                .then(res => {
                    resolve(res.data.data)
                })
                .catch(error => {
                    reject(error.response)
                })
            })
        },
        store({ commit, getters }, formData) {
            return new Promise((resolve, reject) => {
                axios.post('client', formData)
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        update({ commit, getters }, formData) {
            return new Promise((resolve, reject) => {
                axios.put(`client/${formData._id}`, formData)
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        destroy({ commit, getters }, id) {
            return new Promise((resolve, reject) => {
                axios.delete(`client/${id}`)
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        transactionsByCustomer({ commit, getters }, {clientId, query}) {
            return new Promise((resolve, reject) => {
                axios.get( `client/${clientId}/transactions?createdAt=${query.createdAt}&currency=${query.currencyId}&from=${query.from}&reference=${query.reference}`)
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response)
                })
            })
        },
        getClientsByEmail({ commit, getters }, email) {
            return new Promise((resolve, reject) => {
                axios.get(`client/email/${email}`)
                  .then(res => {
                      resolve(res.data)
                  })
                  .catch(error => {
                      reject(error.response.data)
                  })
            })
        },
        transfer({ commit, getters }, {id, formData}) {
            return new Promise((resolve, reject) => {
                axios.patch(`wallet/updateBalanceRoot/${id}`, formData)
                  .then(res => {
                      resolve(res.data)
                  })
                  .catch(error => {
                      reject(error.response.data)
                  })
            })
        },
        showClientBalance({ commit, getters }, {clientId, currencyId}) {
            return new Promise((resolve, reject) => {
                axios.get(`client/${clientId}/${currencyId}/balance`)
                  .then(res => {
                      resolve(res.data)
                  })
                  .catch(error => {
                      reject(error.response.data)
                  })
            })
        },
        showAllClientBalance({ commit, getters }, {clientId}) {
            return new Promise((resolve, reject) => {
                axios.get(`client/${clientId}/balance`)
                  .then(res => {
                      resolve(res.data)
                  })
                  .catch(error => {
                      reject(error.response.data)
                  })
            })
        },

    }
}